import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { ActionableNotification, InlineLoading } from '@carbon/react';

import { useNotifications } from 'core/notifications';
import useMutateUnfinalProject from 'shared/api/projects/useMutateUnfinalProject';
import { createUseProjectQueryKey } from 'shared/api/projects/useProjectQuery';
import styles from 'theme/features/shared/marked-as-final-notification.module.scss';

const MarkedAsFinalNotification = ({ projectId }) => {
  const queryClient = useQueryClient();

  const [isNotificationVisible, setIsNotificationVisible] = useState(true);

  const { showSuccessNotification, showErrorNotification } = useNotifications();

  const unfinalProjectMutation = useMutateUnfinalProject({
    onError: () => showErrorNotification({ description: 'Failed to remove final mark' }),
    onSuccess: () => {
      queryClient.setQueryData(createUseProjectQueryKey(projectId), (prevProject) => ({
        ...prevProject,
        details: {
          ...prevProject.details,
          isFinal: false
        }
      }));

      setIsNotificationVisible(false);
      showSuccessNotification({ description: 'Removed final successfully' });
    }
  });

  return isNotificationVisible ? (
    <ActionableNotification
      kind="warning"
      lowContrast
      className={styles.notification}
      actionButtonLabel=""
      subtitle={
        <div className={styles.subtitle}>
          Please note, projects generated through the LCS tool are meant to serve as guidelines. All recommendations
          must be verified on-site considering local conditions. To edit this version you will have to
          {unfinalProjectMutation.isLoading ? (
            <InlineLoading
              status="active"
              iconDescription="Loading"
              description="Undoing final..."
              className={styles.loader}
            />
          ) : (
            <button className={styles['undo-final']} onClick={() => unfinalProjectMutation.mutate(projectId)}>
              Undo Final
            </button>
          )}
        </div>
      }
    />
  ) : null;
};

export default MarkedAsFinalNotification;
